import * as React from "react";
import { FormHeadingLogo, SeparatingBar } from "../ui";

export const HeadingLogo = () => (
  <>
    <FormHeadingLogo />
    <SeparatingBar />
  </>
);
